// src/services/tradingBotService.ts
import api from "./api";

const tradingBotService = {
  getAvailableBots: async () => {
    const response = await api.get("/trading/bots");
    return response.data;
  },

  /** Legacy: returns the single most-recently-joined active bot */
  getActiveBot: async () => {
    const response = await api.get("/trading/active-bot");
    return response.data;
  },

  /** New: returns ALL active bot subscriptions for the user */
  getActiveBots: async () => {
    const response = await api.get("/trading/active-bots");
    return response.data;
  },

  joinBot: async (botId: number, amount: number) => {
    const response = await api.post("/trading/join-bot", {
      bot_id: botId,
      amount: amount,
    });
    return response.data;
  },

  /**
   * Leave a specific active bot subscription.
   * @param botId         The bot's id
   * @param subscriptionId  Optional pivot row id — pass when the user has
   *                        joined the same bot more than once to target a
   *                        specific subscription.
   */
  leaveBot: async (botId: number, subscriptionId?: number) => {
    const response = await api.post("/trading/leave-bot", {
      bot_id: botId,
      ...(subscriptionId !== undefined
        ? { subscription_id: subscriptionId }
        : {}),
    });
    return response.data;
  },

  getBotEarnings: async () => {
    const response = await api.get("/trading/bot-earnings");
    return response.data;
  },
};

export default tradingBotService;
